import { render, staticRenderFns } from "./GlossaryWiki.vue?vue&type=template&id=d0139008&scoped=true&"
import script from "./GlossaryWiki.vue?vue&type=script&lang=ts&"
export * from "./GlossaryWiki.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0139008",
  null
  
)

export default component.exports